import * as React from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router';
import { Layout } from 'shared/components/Layout';
import IdeaLanding from 'modules/IdeaLanding';
import StockLanding from 'modules/StockLanding';
import NotFound from 'shared/components/NotFound';
import { StocksPage } from 'modules/StockPage';

interface Props {}

type Enhanced = Props & RouteComponentProps<Props>;

export const Router: React.FC<Enhanced> = ({ match: { path: root } }) => {
  return (
    <Switch>
      <Layout>
        <Switch>
          <Route path={`${root}/idea/:ideaType/:id(\\d+)`} component={IdeaLanding} />
          <Route path={`${root}/stocks/:id(\\d+)`} component={StockLanding} />
          <Route path={`${root}/stocks`} component={StocksPage} />
          <Route component={NotFound} />
        </Switch>
      </Layout>
    </Switch>
  );
};
